module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.msg)
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.itemNew),
      expression: "itemNew"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.itemNew)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addNew.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.itemNew = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ul', _vm._l((_vm.items), function(item) {
    return _c('li', {
      class: {
        isStudent: item.student
      },
      on: {
        "click": function($event) {
          return _vm.turnRed(item)
        }
      }
    }, [_vm._v("\n  \t\t" + _vm._s(item.name) + "\n  \t")])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 18
// module chunks = 1